import { render, staticRenderFns } from "./ImportRateExcel.vue?vue&type=template&id=55205e40&scoped=true&"
import script from "./ImportRateExcel.vue?vue&type=script&lang=js&"
export * from "./ImportRateExcel.vue?vue&type=script&lang=js&"
import style0 from "./ImportRateExcel.vue?vue&type=style&index=0&id=55205e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55205e40",
  null
  
)

export default component.exports